<template>
  <view>
    <goods-detail :mid="mid" @createOrder="handleCreateOrder" />
  </view>
</template>

<script>
import GoodsDetail from '@/components/goods/GoodsDetail';
export default {
  name: 'goodsDemo',
  components: {
    GoodsDetail,
  },
  data() {
    return {
      mid: null,
    };
  },
  onLoad(query) {
    // console.log('%c [aaa]: ', 'color:#1989fa;', query);
    this.mid = query.mid;
  },
  methods: {
    handleCreateOrder(orderForm) {
      const createOrderUrl = `/demo/pages/mall/newOrder?orderForm=${JSON.stringify(orderForm)}`;
      uni.navigateTo({
        url: createOrderUrl,
      });
    },
  },
};
</script>

<style scoped></style>
